import { NativeDateAdapter } from '@angular/material/core';

export class CustomDateAdapter extends NativeDateAdapter {
  override getDayOfWeekNames(style: 'long' | 'short' | 'narrow'): string[] {
    const locale = (this.locale || 'en').toLowerCase();
    const isSpanish = locale.startsWith('es');

    // Order MUST be Sunday -> Saturday to match Angular Material expectations.
    if (isSpanish) {
      // Single-letter abbreviations (Sunday->Saturday) => D L M M J V S
      if (style === 'narrow') {
        return ['D', 'L', 'M', 'M', 'J', 'V', 'S'];
      }
      if (style === 'short') {
        return ['D', 'L', 'M', 'M', 'J', 'V', 'S'];
      }
      if (style === 'long') {
        return ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
      }
    } else {
      // English
      if (style === 'narrow') {
        return ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
      }
      if (style === 'short') {
        return ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
      }
      if (style === 'long') {
        return ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      }
    }

    return super.getDayOfWeekNames(style);
  }
}
